import { Link, useLocation } from "react-router-dom"
import "./accountNav.css"

export function AccountNav() {
    const location = useLocation()

    const accountLinks = {
        profile: {
            path: "/account",
            text: "My Profile"
        },
        adressBook: {
            path: "/account/addressBook",
            text: "Address Book"
        },
        paymentOptions: {
            path: "/account/payment",
            text: "Payment Options"
        }
    }

    const accountLinksKeys = Object.keys(accountLinks)

    const ordersLinks = {
        orders: {
            path: "/account/orders",
            text: "Orders"
        },
        deliveries: {
            path: "/account/deliveries",
            text: "My Deliveries"
        },
        returns: {
            path: "/account/returns",
            text: "My Returns"
        },
        cancellations: {
            path: "/account/cancellations",
            text: "My Cancellations"
        }
    }

    const ordersLinksKeys = Object.keys(ordersLinks)

    return (
        <div className="d-flex account-nav pe-5 lg-col">
            <div className="mb-2">
                <h6>Manage My Account</h6>
                <div className="user-links py-2 d-flex flex-column gap-2">
                    {
                        accountLinksKeys.map((e, i) => (
                            <div key={i}>
                                <Link
                                    to={accountLinks[e].path}
                                    className={location.pathname === accountLinks[e].path ? "on" : ""}>
                                        {accountLinks[e].text}
                                </Link>
                            </div>
                        ))
                    }
                </div>
            </div>

            <div className="mb-2">
                <h6>My Orders</h6>
                <div className="user-links py-2 d-flex flex-column gap-2">
                    {
                        ordersLinksKeys.map((e, i) => (
                            <div key={i}>
                                <Link
                                    to={ordersLinks[e].path}
                                    className={location.pathname === ordersLinks[e].path ? "on" : ""}>
                                        {ordersLinks[e].text}
                                </Link>
                            </div>
                        ))
                    }
                </div>
            </div>

            <div>
                <h6>My WishList</h6>
            </div>
        </div>
    )
}